import React, { useEffect, useState } from "react";
import {
  Container, Paper, Button, MenuItem, Select, FormControl, InputLabel, TextField, Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { useUsuario } from "../../context/usuarioContext";
import useListarSim from "../../queries/sim/useListarSim";
import useCompararSim from "../../queries/sim/useCompararSim";
import useCambioSim from "../../queries/sim/useCambioSim";
import Swal from "sweetalert2";

const Sim = () => {
  const [simAntigua, setSimAntigua] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [ultimosDigitos, setUltimosDigitos] = useState("");

  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedText, setIsFocusedText] = useState(false);

  const { contratoSeleccionado } = useUsuario();
  const { mutate: listarSim, sims } = useListarSim();
  const { mutate: compararSim } = useCompararSim();
  const { mutate: cambiarSim } = useCambioSim();
  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    if (contratoSeleccionado?.linea) {
      listarSim({ numero_linea: contratoSeleccionado.linea });
    }
  }, [contratoSeleccionado]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setUltimosDigitos("");
  };

  const handleSubmit = () => {

    compararSim(
      { numero_linea: contratoSeleccionado.linea, ultimos_digitos: ultimosDigitos },
      {
        onSuccess: (response) => {
          if (response.success) {

            cambiarSim(
              {
                cont_id: contratoSeleccionado.id_contrato,
                ultimos_digitos: ultimosDigitos
              },
              {
                onSuccess: () => {
                  Swal.fire({
                    icon: "success",
                    title: "Cambio de SIM exitoso",
                    text: "Tu SIM ha sido cambiada correctamente.",
                    confirmButtonColor: "#00657D",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      listarSim({ numero_linea: contratoSeleccionado.linea });
                      setIsDisable(true);
                    }
                  });
                },
                onError: () => {
                  console.error("Error en cambio de SIM");
                  Swal.fire({
                    icon: "error",
                    title: "Error en cambio de SIM",
                    text: "No se pudo completar el cambio de SIM. Inténtalo nuevamente.",
                    confirmButtonColor: "#d33",
                  });
                },
              }
            );
          } else {
            console.error("Los 4 últimos dígitos no coinciden. Intenta nuevamente.");
            Swal.fire({
              icon: "warning",
              title: "Dígitos incorrectos",
              text: "Los últimos 4 dígitos no coinciden con la SIM nueva.",
              confirmButtonColor: "#ffa500",
            });
          }
        },
        onError: (error) => {
          console.error("Error al verificar la SIM:", error);
          Swal.fire({
            icon: "error",
            title: "Error en verificación",
            text: "Ocurrió un error al verificar la SIM. Inténtalo nuevamente.",
            confirmButtonColor: "#d33",
          });
        },
      }
    );

    handleCloseModal();
  };

  return (
    <Container>
      <div style={{ display: "grid", placeItems: "center", marginBottom: "2rem" }}>
        <Paper elevation={3} style={{ padding: "2rem", width: "300px", textAlign: "center" }}>
          <FormControl fullWidth style={{ marginBottom: "1rem" }}>
            <InputLabel
              htmlFor="sim-select"
              shrink={isFocused || !!simAntigua}
            >
              SIM antigua
            </InputLabel>
            <Select
              id="sim-select"
              value={simAntigua}
              onChange={(e) => setSimAntigua(e.target.value)}
              label="SIM antigua"
              notched={isFocused || !!simAntigua}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
            >
              {sims.length > 0 ? (
                sims.map((sim, index) => (
                  <MenuItem key={index} value={sim.sim_antigua}>
                    {sim.sim_antigua} (Línea: {sim.numero_linea})
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay SIMs disponibles</MenuItem>
              )}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            sx={{ backgroundColor: "rgb(0, 101, 125)", "&:hover": { backgroundColor: "rgb(0, 85, 105)" } }}
            disabled={!simAntigua || isDisable}
            onClick={handleOpenModal}
          >
            Enviar
          </Button>
        </Paper>
      </div>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle
        >Verificación de SIM</DialogTitle>
        <DialogContent >
          <TextField
            style={{ marginTop: '6px' }}
            id="sim-verify"
            fullWidth
            label="Últimos 4 caracteres de la nueva SIM"
            variant="outlined"
            inputProps={{ maxLength: 4 }}
            value={ultimosDigitos}
            onChange={(e) => {
              const inputValue = e.target.value.slice(0, 4);
              setUltimosDigitos(inputValue);
            }}
            notched={isFocusedText}
            onFocus={() => setIsFocusedText(true)}
            onBlur={() => setIsFocusedText(false)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">Cancelar</Button>
          <Button
            onClick={handleSubmit}
            sx={{ backgroundColor: "rgb(0, 101, 125)", "&:hover": { backgroundColor: "rgb(0, 85, 105)" } }}
            variant="contained"
            disabled={ultimosDigitos.length !== 4}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Sim;
